import React from "react";
import PropTypes from "prop-types";
import ScoringKnockoutCriteriaListComponent from "./ScoringKnockoutCriteriaListComponent";

class ScoringKnockoutCriteriaListContainer extends React.PureComponent {
  // Useless, for now - The card is read-only. Will be kept fo future developments (save, property change)
  state = {
    knockoutCriteriaList: this.props.knockoutCriteriaList
  };

  componentDidUpdate(prevProps) {
    if (prevProps.knockoutCriteriaList !== this.props.knockoutCriteriaList) {
      this.setState(prevState => ({
        ...prevState,
        knockoutCriteriaList: this.props.knockoutCriteriaList
      }));
    }
  }

  render() {
    const { knockoutCriteriaList } = this.props;
    return <ScoringKnockoutCriteriaListComponent knockoutCriteriaList={knockoutCriteriaList} />;
  }
}

ScoringKnockoutCriteriaListContainer.propTypes = {
  knockoutCriteriaList: PropTypes.array.isRequired
};

export default ScoringKnockoutCriteriaListContainer;
